import { Styles } from "../../../types/common";

const styles: Styles = {
  StyledPagination: {
    alignItems: "center",
    display: "flex",
    gap: "16px",
    padding: "10px 20px",
    borderRadius: "0px 0px 16px 16px",
    border: "1px solid rgba(3, 92, 103, 0.25)",
    background: " #F4F4F4",
    boxShadow: "0px 1px 4px 0px rgba(84, 86, 90, 0.24)",
    ".navigate": {
      fontSize: "14px",
      background: "transparent",
      border: "none",
      outline: "none",
      color: "#005CB9",
      display: "flex",
      alignItems: "center",
      padding: "0",
      gap: "5px",
      svg: {
        fontSize: "14px",
      },
      cursor: "pointer",
      ":disabled": {
        opacity: "0.5",
        cursor: "auto",
      },
    },
    ".pages": {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      gap: "5px",
      textDecorationThickness: "2px",
      textUnderlineOffset: "2px",
      button: {
        cursor: "pointer",
        textDecoration: "underline",
        background: "transparent",
        border: "none",
        outline: "none",
        color: "#005CB9",
      },
      ".active": {
        cursor: "default",
        fontWeight: "700",
        textDecoration: "none",
        color: "#005CB9",
      },
      span: {
        color: "#005CB9",
      },
    },
  },
  jumpTo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    ".label": {
      fontSize: "14px",
    },
    ".pages_list__option": {
      fontSize: "14px",
      padding: "2px 5px",
    },
    ".pages_list__option--is-focused": {
      cursor: "pointer",
    },
    " .pages_list__menu-list": {
      maxHeight: "170px",
    },
    " .pages_list__control": {
      minHeight: "29px",
      padding: "0 4px",
    },
    ".pages_list__value-container": {
      padding: 0,
      fontSize: "14px",
      input: {
        fontSize: "14px !important",
      },
    },
    ".pages_list__indicator-separator": {
      display: "none",
    },
    ".pages_list__indicator": {
      padding: "2px 5px",
    },
  },
};

export default styles;
